import { isEmpty, some, values } from 'lodash'

const hasCheckedKeywords = checkedKeywordKeys =>
  some(
    values(checkedKeywordKeys),
    checkedMainColumn => !isEmpty(checkedMainColumn),
  )

export default hasCheckedKeywords
